import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import './index.css';

// Pages are lazy-loaded chunks with hashed filenames that change on every
// deploy. A tab opened before a deploy still asks for the old names, and
// Netlify's SPA fallback answers with index.html, so the import fails and the
// router shows its error page. Reload once to pick up the current build; the
// timestamp guard stops a loop if the chunk is genuinely broken.
window.addEventListener('vite:preloadError', (event) => {
  const KEY = 'gba:chunk-reload-at';
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(KEY)) || 0;
  } catch {
    // Storage unavailable (private mode etc.): fall through and reload once.
  }
  if (Date.now() - last < 10_000) return;
  try {
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // Ignore; worst case is a single extra reload.
  }
  event.preventDefault();
  window.location.reload();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
);
